


















import Vue, {VueConstructor} from 'vue'
import {fieldProps} from '../BZCore/ActiveField'
import Errors from '../errors.vue'
import UiSelectInput from '../../Inputs/SelectInput.vue'


export default (Vue as VueConstructor<Vue & {
  multiSelect: boolean
}>).extend({
  name: 'SelectField',
  props: fieldProps,
  components: {Errors, UiSelectInput},
  data () {
    return {
      selectList: [],
    }
  },
  created () {
    this.makeSelectList()
  },
  methods: {
    onInput (event: any) {
      this.$emit('input', event)
    },
    async makeSelectList () {
      if (Array.isArray(this.fieldOptions.values)) {
        this.selectList = this.fieldOptions.values
      } else if (typeof this.fieldOptions.values === 'function') {
        this.selectList = await this.fieldOptions.values(this.scope)
      } else {
        console.error('can not get value list!', this.field, this.scope)
        this.selectList = []
      }
    },
  },
  watch: {
    scope: {
      handler () {
        this.makeSelectList()
      },
      deep: true
    },
  },
  computed: {
    currentValue: {
      get (): any {
        if (this.multiSelect && !this.value) {
          return [];
        }
        return this.value
      },
      set () {

      }
    }
  }
})
